// extracted by mini-css-extract-plugin
export default {"departments":"IM-z","departmentHeading":"JM-z","departmentSection":"KM-z","departmentName":"LM-z","departmentLink":"MM-z","expandIcon":"NM-z"};